import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { onCLS, onINP, onFCP, onLCP, onTTFB } from 'web-vitals';

// Web Vitals Monitoring
function sendToAnalytics(metric: any) {
  try {
    if (window.gtag) {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
      });
    }
  } catch (error) {
    console.warn('⚠️ Analytics error:', error);
    // Analytics hatası uygulamayı durdurmasın
  }
}

// Monitor Core Web Vitals
try {
  onCLS(sendToAnalytics);
  onINP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onLCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
} catch (error) {
  console.warn('⚠️ Web Vitals initialization error:', error);
}

createRoot(document.getElementById("root")!).render(<App />);
